export class GuidedLinkChips {
  beforeTitle?:Array<GuidedLinkChip>;
  afterTitle?:Array<GuidedLinkChip>;
}

/**
 * Chip is the explicit highlight of the match that is done outside of the title,
 * for example EAN code or CommRef.
 * For example check https://www.se.com/se/sv/ and type 30364 in search
 */
export class GuidedLinkChip{
  icon?: string;
  cssClass?: string;
  label?:string;
  text: string;
}

export abstract class GuidedItemBase{
  /**To which section the link belongs to?*/
  sectionId: string;
  /**
     * Text that should be clicked, link name as text
     */
  title: string;

  /**
     * Link to be shown as HTML, with highlighting if enabled in the API component
     */
  markup: string;
  /**
     * Where to go when clicking?
     */
  openUrl: string;

    /**
     * Check if link is internal. All suggestions should be internal links by design,
     * but quicklinks might be not.
     */
    abstract isExternal(): boolean;

    /**
     * Chips are the highlighted details field displayed before/after the link title, when match is not on the title but on that fields
     */
    chips?: GuidedLinkChips;

    /**
     * The original item from the API, for integration purposes
     */
    _original?: any; //eslint-disable-line @typescript-eslint/no-explicit-any
}

export class GuidedApiQuickLink extends GuidedItemBase{

  /**
     * Optional image
     */
  image?: string;


  /**
     * Set when link is external, UI must show external link flag when isExternal is set
     * Can be overriden by the backend component to use different logic
     */
  isExternal() {
      const containsCurrentHostPrefix = this.openUrl.indexOf(window.location.hostname) !== -1;
      const containsSeHostPrefix = this.openUrl.indexOf('https://www.se.com') == -1;
      return containsSeHostPrefix || containsCurrentHostPrefix;
  }



  static from(input: Partial<GuidedApiQuickLink>): GuidedApiQuickLink {
      return Object.assign(new GuidedApiQuickLink(), input);
  }
  quartzIcon?: string;
}

export class GuidedNoResult extends GuidedItemBase {
  quartzIcon?: string;

  /**
   * Text that should be clicked, link name as text
   */
  text?: string;

  isExternal() {
      return false;
  }

  static from(input: Partial<GuidedNoResult>): GuidedNoResult {
      return Object.assign(new GuidedNoResult(), input);
  }
}
export class GuidedApiSuggestion extends GuidedItemBase{

  /**
     * Second line of text, smaller
     */
  description?: string;

  quartzIcon?: string;

  //typescript cries about missing property when this is gone
  //but all suggestions should be internal links by design
  // noinspection JSUnusedGlobalSymbols
  isExternal() {
      return false;
  }

  static from(input: Partial<GuidedApiSuggestion>): GuidedApiSuggestion {
      return Object.assign(new GuidedApiSuggestion(), input);
  }
}

export interface GuidedSearchLoaded{
    term: string;
    category?: string;
    /**
     * How long did it took to load suggestions?
     */
    duration_ms: number;
}
/**
 * Sent up the DOM when Guided Search component can't find the `target` component,
 * when the user clicks the link or pressess enter accepting the search text.
 * Event must be subscribed by Analytics component!
 */
export interface GuidedSearchCompleted{
    term: string;
    /**
     * Null if user pressed enter, present when user clicked the link
     */
    event?: string;
    section?: string;
    category?: string,
    link: null | GuidedApiSuggestion | GuidedApiQuickLink,
    openUrl?: string,
}
/**
 * Sent up the DOM when user types in the Guided Search box
 * Event must be subscribed by Analytics component!
 */
export interface GuidedSearchUserTyping {
    term: string;
}

/**
 * Sent up the DOM when user changes the highlighted link with mouse or keyboard
 * Contextual component can prefetch/reload the results depending on what's selected
 */
export interface GuidedSearchHighlighting{
    term: string;
    index: number;
    link: GuidedApiSuggestion | GuidedApiQuickLink
}
